// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__H-YlO","dadosPlano":"OptionSelect_dadosPlano__1K0FA","focado":"OptionSelect_focado__3j3LJ"};